var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-card',[_c('b-button',{staticClass:"mb-75",attrs:{"variant":"outline-secondary","block":""},on:{"click":_vm.printInvoice}},[_vm._v(" "+_vm._s(_vm.$t('print'))+" ")]),_c('b-button',{staticClass:"mb-75",attrs:{"to":{
        name: 'uploadRemission',
        params: { purchaseOrderId: _vm.purchaseOrder.id },
      },"variant":"outline-success","block":""}},[_vm._v(" "+_vm._s(_vm.$t('remission'))+" ")]),_c('b-button',{staticClass:"mb-75",attrs:{"to":{
        name: 'purchaseOrders',
        params: { quoteId: _vm.$route.params.quoteId },
      },"variant":"outline-success","block":""}},[_vm._v(" "+_vm._s(_vm.$t('invoice2'))+" ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }